__turbopack_context__.v({
  "container": "Footer-module__rnk_JG__container",
  "container__contact": "Footer-module__rnk_JG__container__contact",
  "container__contact__item": "Footer-module__rnk_JG__container__contact__item",
  "container__flex": "Footer-module__rnk_JG__container__flex",
  "container__flex_top": "Footer-module__rnk_JG__container__flex_top",
  "container__legal": "Footer-module__rnk_JG__container__legal",
  "container__logotipo": "Footer-module__rnk_JG__container__logotipo",
  "container__logotipo__m2d": "Footer-module__rnk_JG__container__logotipo__m2d",
  "container__marevera": "Footer-module__rnk_JG__container__marevera",
  "container__marevera__adress": "Footer-module__rnk_JG__container__marevera__adress",
  "container__marevera__icon": "Footer-module__rnk_JG__container__marevera__icon",
  "container__nav": "Footer-module__rnk_JG__container__nav",
});
